import React from 'react';

const FacebookIcon: React.FC<
  React.PropsWithChildren<React.SVGProps<SVGSVGElement>>
> = (props) => {
  return (
    <svg
      width="32.24px"
      height="32.24px"
      viewBox="0 0 32.24 32.24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <title>DE1D0970-48FA-419C-8D5D-19DCFCA2FE30</title>
      <defs>
        <polygon
          id="path-1"
          points="0 0 31.538036 0 31.538036 31.53816 0 31.53816"
        ></polygon>
      </defs>
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="BBdomu.cz_prihlasen" transform="translate(-72, -3289)">
          <g id="pata" transform="translate(0, 2971)">
            <rect
              id="Mask"
              fill="#E9B400"
              x="0"
              y="0"
              width="1440"
              height="574"
            ></rect>
            <g id="fb" transform="translate(72, 318)">
              <mask id="mask-2" fill="white">
                <use xlinkHref="#path-1"></use>
              </mask>
              <g id="Clip-2"></g>
              <path
                d="M20.168476,9.57776 L18.091476,9.57776 C17.357396,9.57776 17.204876,9.87784 17.204876,10.63672 L17.204876,12.46944 L20.168476,12.46944 L19.883276,15.68848 L17.204876,15.68848 L17.204876,25.30096 L13.365836,25.30096 L13.365836,15.72816 L11.369436,15.72816 L11.369436,12.46944 L13.365836,12.46944 L13.365836,9.90388 C13.365836,7.4958 14.654196,6.2372 17.509916,6.2372 L20.168476,6.2372 L20.168476,9.57776 Z M15.768956,0 L15.768956,0 C7.060436,0 -0.000124,7.06056 -0.000124,15.76908 C-0.000124,24.4776 7.060436,31.53816 15.768956,31.53816 C24.478716,31.53816 31.538036,24.4776 31.538036,15.76908 C31.538036,7.06056 24.478716,0 15.768956,0 L15.768956,0 Z"
                id="Fill-1"
                fill="#5A3218"
                mask="url(#mask-2)"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default FacebookIcon;
